module.exports = require("uuid/v4");


//////////////////
// WEBPACK FOOTER
// external "uuid/v4"
// module id = 3
// module chunks = 0